export default __webpack_public_path__ + "static/media/map_spain.fd674ba5.png";